import { Result, Spin } from 'antd'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'

import type { Role } from '../api/types'
import { useAuth } from './AuthContext'

interface Props {
  children: ReactNode
  /** Minimum role; omit to allow any signed-in user. */
  role?: Role
  /** Cho phép role transcoder (mặc định đóng, như AllowTranscoder phía server). */
  transcoder?: boolean
  /** Chỉ role transcoder (trang riêng của user). */
  transcoderOnly?: boolean
}

export function RequireAuth({ children, role, transcoder, transcoderOnly }: Props) {
  const { status, user, can } = useAuth()
  const location = useLocation()

  if (status === 'loading') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" />
      </div>
    )
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  if (transcoderOnly && user?.role !== 'transcoder') {
    return <Result status="403" title="403" subTitle="Bạn không có quyền truy cập trang này." />
  }
  if (role && !(user?.role === 'transcoder' ? transcoder === true : can(role))) {
    return <Result status="403" title="403" subTitle="Bạn không có quyền truy cập trang này." />
  }
  return <>{children}</>
}
